import React from 'react';
import { Box, IconButton } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';
import { EVENT_VIEW_MODES } from '../eventsListData';

const EventsViewToggle = ({ viewMode, onViewModeChange }) => {
  const isList = viewMode === EVENT_VIEW_MODES.LIST;

  const toggleSx = (active) => ({
    width: 40,
    height: 40,
    borderRadius: 1.5,
    border: '1px solid',
    borderColor: active ? 'primary.main' : 'divider',
    bgcolor: active ? 'primary.main' : 'background.paper',
    color: active ? 'primary.contrastText' : 'text.secondary',
    '&:hover': {
      bgcolor: active ? 'primary.dark' : 'action.hover',
    },
  });

  return (
    <Box sx={{ display: 'flex', gap: 0.75 }}>
      <IconButton
        aria-label="List view"
        onClick={() => onViewModeChange(EVENT_VIEW_MODES.LIST)}
        sx={toggleSx(isList)}
      >
        <ViewListIcon fontSize="small" />
      </IconButton>
      <IconButton
        aria-label="Grid view"
        onClick={() => onViewModeChange(EVENT_VIEW_MODES.GRID)}
        sx={toggleSx(!isList)}
      >
        <GridViewIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default EventsViewToggle;
